import { DashboardAction, DashboardState } from '@/app/dashboard/store/dashboard-content-reducer';
import { useEffect } from 'react';
import { preferencesApi, PreferenceConstants } from '@/core/preferences/export';
import { compareDashboardSets } from '@/app/dashboard/util/dashboard-util';

export default function useDashboardPersistence({
  state,
  dispatch,
}: {
  state: DashboardState;
  dispatch: (p: DashboardAction) => void;
}) {
  useEffect(() => {
    console.warn('Dashboard State Change', state);

    if (state.dirty && !state.loading && (!state.editing || state.saveWhileEditing)) {
      console.info('Saving Dashboard', state.dashboards);
      if (!state.dashboards) return;

      if (compareDashboardSets(state.lastSavedDashboards, state.dashboards)) {
        console.info(
          'No Meaningful changes, returning',
          state.lastSavedDashboards,
          state.dashboards,
        );
        dispatch({ type: 'stopEditingCurrentDashboard' });
        return;
      }

      console.info(' Meaningful changes, saving', state.lastSavedDashboards, state.dashboards);

      preferencesApi
        .upsertPreferences(PreferenceConstants.MY_MNI, { dashboard: state.dashboards })
        .then(value => {
          dispatch({ type: 'recordSavedDashboards', dashboards: value.dashboard });
          dispatch({ type: 'stopEditingCurrentDashboard' });
        });
    }
    // eslint-disable-next-line
  }, [state, state.dirty]);

  useEffect(() => {
    if (state.selectedDashboard) {
      console.log('Saving selected dashboard to local storage');
      localStorage.setItem('selectedDashboard', state.selectedDashboard);
    }
  }, [state.selectedDashboard]);
}
